<template>
  <MarketplaceCard
    v-if="integrations"
    v-model="integrations.pulse_m.enabled"
    logo-alt="PulseM"
    description="The #1 online review management platform for home services. Easily connect with industry-leading field management software."
    learn-more-link="https://pulsem.me/"
    cy-selector="marketplacePulseM"
  >
    <template #logo>
      <PulseMLogo class="h-11 w-auto mr-auto" />
    </template>
    <template #configure>
      <div>
        <div class="link" @click="toggleModal">Set Up Information</div>
      </div>
    </template>
    <template #modal>
      <div>
        <Modal
          v-if="modalOpen"
          title="Set Up Information - pulseM"
          class-name="pulse-m-config-modal"
          @submit="handleSave"
          @hide-modal="toggleModal"
        >
          <div class="d-flex flex-column">
            <InputField
              v-model="integrations.pulse_m.api_key"
              class="!mb-0"
              title="API Key"
              type="password"
              placeholder="API Key"
              toggleable
              :validation="
                v$.integrations.pulse_m.api_key.$error ? 'error' : 'none'
              "
              :helper-text="
                v$.integrations.pulse_m.api_key.$errors[0]?.$message || null
              "
            />
          </div>
        </Modal>
      </div>
    </template>
  </MarketplaceCard>
</template>

<script>
import { mapActions, mapState } from "vuex";

import Modal from "@/components/Modal.vue";
import InputField from "@/components/Seranova/InputField/InputField.vue";
import PulseMLogo from "@/images/pulsem_logo.svg?component";
import useVuelidate from "@vuelidate/core";
import { required } from "@vuelidate/validators";
import MarketplaceCard from "./MarketplaceCard.vue";

export default {
  components: {
    MarketplaceCard,
    Modal,
    InputField,
    PulseMLogo
  },
  data() {
    return {
      modalOpen: false,
      initialEnabledValueLoaded: false
    };
  },
  computed: {
    ...mapState(["integrations"])
  },
  watch: {
    "integrations.pulse_m.enabled": function (newValue, oldValue) {
      if (!this.initialEnabledValueLoaded) {
        this.initialEnabledValueLoaded = true;
        return;
      }

      if (newValue !== oldValue) {
        this.updateEnabled();
      }
    }
  },
  mounted() {
    this.fetchIntegrations();
  },
  setup() {
    return {
      v$: useVuelidate()
    };
  },
  validations() {
    return {
      integrations: {
        pulse_m: {
          api_key: { required, $autoDirty: true }
        }
      }
    };
  },
  methods: {
    ...mapActions(["fetchIntegrations", "updateIntegrations"]),
    handleSave() {
      this.v$.$validate().then((valid) => {
        if (valid) {
          this.updateIntegrations({
            integrations: this.integrations
          }).then(() => {
            window.notify.success("pulseM settings saved!");
            this.toggleModal();
          });
        }
      });
    },
    updateEnabled() {
      const en = this.integrations.pulse_m.enabled;
      this.updateIntegrations({
        integrations: { pulse_m: { enabled: en } }
      }).then(() => {
        window.notify.success(`pulseM ${en ? "enabled" : "disabled"}!`);
      });
    },
    toggleModal() {
      this.modalOpen = !this.modalOpen;
    }
  }
};
</script>
